import React from 'react'

export const GuidesStyles: { [key: string]: React.CSSProperties } = {
    container: {
        width: '100%',
        position: 'relative',
    },
    content: {
        width: '100%',
        paddingTop: 10,
        display: 'flex',
        overflow: 'auto',
        paddingBottom: 10,
        flexWrap: 'nowrap',
    },
    btnContent: {
        width: 220,
        minWidth: 220,
        maxWidth: 220,
        height: 181,
        minHeight: 160,
        maxHeight: 160,
        marginLeft: 5,
        marginRight: 10,
        display: 'flex',
        borderRadius: 10,
        cursor: 'pointer',
        position: 'relative',
        flexDirection: 'column',
        backgroundColor: '#fff',
        boxShadow: '0px 1px 3px 0px #0000001A',
    },
    btnTop: {
        padding: 7,
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'flex-end',
        boxSizing: 'border-box',
        justifyContent: 'flex-end',
    },
    btnBody: {
        flex: 1,
        paddingLeft: 10,
        display: 'flex',
        paddingRight: 10,
        textAlign: 'center',
        alignItems: 'center',
        justifyContent: 'center',
    },
    btnFooter: {
        paddingTop: 5,
        paddingLeft: 10,
        paddingRight: 10,
        paddingBottom: 10,
    },
    btnFooterBtn: {
        paddingTop: 5,
        paddingLeft: 5,
        borderRadius: 5,
        paddingRight: 5,
        paddingBottom: 1,
        alignItems: 'center',
        display: 'inline-block',
        justifyContent: 'center',
        border: '2px solid #2699D6',
        transform: 'rotate(180deg)',
    },
}
